import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _createClass from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _assertThisInitialized from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { SENSITIVE_STRING } from "@smithy/smithy-client";
import { S3ServiceException as __BaseException } from "./S3ServiceException";
export var RequestCharged = {
  requester: "requester"
};
export var RequestPayer = {
  requester: "requester"
};
export var NoSuchUpload = /*#__PURE__*/function (_BaseException) {
  _inherits(NoSuchUpload, _BaseException);
  var _super = _createSuper(NoSuchUpload);
  function NoSuchUpload(opts) {
    var _this;
    _classCallCheck(this, NoSuchUpload);
    _this = _super.call(this, _objectSpread({
      name: "NoSuchUpload",
      $fault: "client"
    }, opts));
    _this.name = "NoSuchUpload";
    _this.$fault = "client";
    Object.setPrototypeOf(_assertThisInitialized(_this), NoSuchUpload.prototype);
    return _this;
  }
  return _createClass(NoSuchUpload);
}(__BaseException);
export var BucketAccelerateStatus = {
  Enabled: "Enabled",
  Suspended: "Suspended"
};
export var Type = {
  AmazonCustomerByEmail: "AmazonCustomerByEmail",
  CanonicalUser: "CanonicalUser",
  Group: "Group"
};
export var Permission = {
  FULL_CONTROL: "FULL_CONTROL",
  READ: "READ",
  READ_ACP: "READ_ACP",
  WRITE: "WRITE",
  WRITE_ACP: "WRITE_ACP"
};
export var OwnerOverride = {
  Destination: "Destination"
};
export var ServerSideEncryption = {
  AES256: "AES256",
  aws_kms: "aws:kms",
  aws_kms_dsse: "aws:kms:dsse"
};
export var ObjectCannedACL = {
  authenticated_read: "authenticated-read",
  aws_exec_read: "aws-exec-read",
  bucket_owner_full_control: "bucket-owner-full-control",
  bucket_owner_read: "bucket-owner-read",
  private: "private",
  public_read: "public-read",
  public_read_write: "public-read-write"
};
export var ChecksumAlgorithm = {
  CRC32: "CRC32",
  CRC32C: "CRC32C",
  SHA1: "SHA1",
  SHA256: "SHA256"
};
export var MetadataDirective = {
  COPY: "COPY",
  REPLACE: "REPLACE"
};
export var ObjectLockLegalHoldStatus = {
  OFF: "OFF",
  ON: "ON"
};
export var ObjectLockMode = {
  COMPLIANCE: "COMPLIANCE",
  GOVERNANCE: "GOVERNANCE"
};
export var StorageClass = {
  DEEP_ARCHIVE: "DEEP_ARCHIVE",
  EXPRESS_ONEZONE: "EXPRESS_ONEZONE",
  GLACIER: "GLACIER",
  GLACIER_IR: "GLACIER_IR",
  INTELLIGENT_TIERING: "INTELLIGENT_TIERING",
  ONEZONE_IA: "ONEZONE_IA",
  OUTPOSTS: "OUTPOSTS",
  REDUCED_REDUNDANCY: "REDUCED_REDUNDANCY",
  SNOW: "SNOW",
  STANDARD: "STANDARD",
  STANDARD_IA: "STANDARD_IA"
};
export var TaggingDirective = {
  COPY: "COPY",
  REPLACE: "REPLACE"
};
export var ObjectNotInActiveTierError = /*#__PURE__*/function (_BaseException2) {
  _inherits(ObjectNotInActiveTierError, _BaseException2);
  var _super2 = _createSuper(ObjectNotInActiveTierError);
  function ObjectNotInActiveTierError(opts) {
    var _this2;
    _classCallCheck(this, ObjectNotInActiveTierError);
    _this2 = _super2.call(this, _objectSpread({
      name: "ObjectNotInActiveTierError",
      $fault: "client"
    }, opts));
    _this2.name = "ObjectNotInActiveTierError";
    _this2.$fault = "client";
    Object.setPrototypeOf(_assertThisInitialized(_this2), ObjectNotInActiveTierError.prototype);
    return _this2;
  }
  return _createClass(ObjectNotInActiveTierError);
}(__BaseException);
export var BucketAlreadyExists = /*#__PURE__*/function (_BaseException3) {
  _inherits(BucketAlreadyExists, _BaseException3);
  var _super3 = _createSuper(BucketAlreadyExists);
  function BucketAlreadyExists(opts) {
    var _this3;
    _classCallCheck(this, BucketAlreadyExists);
    _this3 = _super3.call(this, _objectSpread({
      name: "BucketAlreadyExists",
      $fault: "client"
    }, opts));
    _this3.name = "BucketAlreadyExists";
    _this3.$fault = "client";
    Object.setPrototypeOf(_assertThisInitialized(_this3), BucketAlreadyExists.prototype);
    return _this3;
  }
  return _createClass(BucketAlreadyExists);
}(__BaseException);
export var BucketAlreadyOwnedByYou = /*#__PURE__*/function (_BaseException4) {
  _inherits(BucketAlreadyOwnedByYou, _BaseException4);
  var _super4 = _createSuper(BucketAlreadyOwnedByYou);
  function BucketAlreadyOwnedByYou(opts) {
    var _this4;
    _classCallCheck(this, BucketAlreadyOwnedByYou);
    _this4 = _super4.call(this, _objectSpread({
      name: "BucketAlreadyOwnedByYou",
      $fault: "client"
    }, opts));
    _this4.name = "BucketAlreadyOwnedByYou";
    _this4.$fault = "client";
    Object.setPrototypeOf(_assertThisInitialized(_this4), BucketAlreadyOwnedByYou.prototype);
    return _this4;
  }
  return _createClass(BucketAlreadyOwnedByYou);
}(__BaseException);
export var BucketCannedACL = {
  authenticated_read: "authenticated-read",
  private: "private",
  public_read: "public-read",
  public_read_write: "public-read-write"
};
export var DataRedundancy = {
  SingleAvailabilityZone: "SingleAvailabilityZone",
  SingleLocalZone: "SingleLocalZone"
};
export var BucketType = {
  Directory: "Directory"
};
export var LocationType = {
  AvailabilityZone: "AvailabilityZone",
  LocalZone: "LocalZone"
};
export var BucketLocationConstraint = {
  EU: "EU",
  af_south_1: "af-south-1",
  ap_east_1: "ap-east-1",
  ap_northeast_1: "ap-northeast-1",
  ap_northeast_2: "ap-northeast-2",
  ap_northeast_3: "ap-northeast-3",
  ap_south_1: "ap-south-1",
  ap_south_2: "ap-south-2",
  ap_southeast_1: "ap-southeast-1",
  ap_southeast_2: "ap-southeast-2",
  ap_southeast_3: "ap-southeast-3",
  ca_central_1: "ca-central-1",
  cn_north_1: "cn-north-1",
  cn_northwest_1: "cn-northwest-1",
  eu_central_1: "eu-central-1",
  eu_north_1: "eu-north-1",
  eu_south_1: "eu-south-1",
  eu_south_2: "eu-south-2",
  eu_west_1: "eu-west-1",
  eu_west_2: "eu-west-2",
  eu_west_3: "eu-west-3",
  me_south_1: "me-south-1",
  sa_east_1: "sa-east-1",
  us_east_2: "us-east-2",
  us_gov_east_1: "us-gov-east-1",
  us_gov_west_1: "us-gov-west-1",
  us_west_1: "us-west-1",
  us_west_2: "us-west-2"
};
export var ObjectOwnership = {
  BucketOwnerEnforced: "BucketOwnerEnforced",
  BucketOwnerPreferred: "BucketOwnerPreferred",
  ObjectWriter: "ObjectWriter"
};
export var SessionMode = {
  ReadOnly: "ReadOnly",
  ReadWrite: "ReadWrite"
};
export var NoSuchBucket = /*#__PURE__*/function (_BaseException5) {
  _inherits(NoSuchBucket, _BaseException5);
  var _super5 = _createSuper(NoSuchBucket);
  function NoSuchBucket(opts) {
    var _this5;
    _classCallCheck(this, NoSuchBucket);
    _this5 = _super5.call(this, _objectSpread({
      name: "NoSuchBucket",
      $fault: "client"
    }, opts));
    _this5.name = "NoSuchBucket";
    _this5.$fault = "client";
    Object.setPrototypeOf(_assertThisInitialized(_this5), NoSuchBucket.prototype);
    return _this5;
  }
  return _createClass(NoSuchBucket);
}(__BaseException);
export var AnalyticsFilter;
(function (AnalyticsFilter) {
  AnalyticsFilter.visit = function (value, visitor) {
    if (value.Prefix !== undefined) return visitor.Prefix(value.Prefix);
    if (value.Tag !== undefined) return visitor.Tag(value.Tag);
    if (value.And !== undefined) return visitor.And(value.And);
    return visitor._(value.$unknown[0], value.$unknown[1]);
  };
})(AnalyticsFilter || (AnalyticsFilter = {}));
export var AnalyticsS3ExportFileFormat = {
  CSV: "CSV"
};
export var StorageClassAnalysisSchemaVersion = {
  V_1: "V_1"
};
export var IntelligentTieringStatus = {
  Disabled: "Disabled",
  Enabled: "Enabled"
};
export var IntelligentTieringAccessTier = {
  ARCHIVE_ACCESS: "ARCHIVE_ACCESS",
  DEEP_ARCHIVE_ACCESS: "DEEP_ARCHIVE_ACCESS"
};
export var InventoryFormat = {
  CSV: "CSV",
  ORC: "ORC",
  Parquet: "Parquet"
};
export var InventoryIncludedObjectVersions = {
  All: "All",
  Current: "Current"
};
export var InventoryOptionalField = {
  BucketKeyStatus: "BucketKeyStatus",
  ChecksumAlgorithm: "ChecksumAlgorithm",
  ETag: "ETag",
  EncryptionStatus: "EncryptionStatus",
  IntelligentTieringAccessTier: "IntelligentTieringAccessTier",
  IsMultipartUploaded: "IsMultipartUploaded",
  LastModifiedDate: "LastModifiedDate",
  ObjectAccessControlList: "ObjectAccessControlList",
  ObjectLockLegalHoldStatus: "ObjectLockLegalHoldStatus",
  ObjectLockMode: "ObjectLockMode",
  ObjectLockRetainUntilDate: "ObjectLockRetainUntilDate",
  ObjectOwner: "ObjectOwner",
  ReplicationStatus: "ReplicationStatus",
  Size: "Size",
  StorageClass: "StorageClass"
};
export var InventoryFrequency = {
  Daily: "Daily",
  Weekly: "Weekly"
};
export var TransitionStorageClass = {
  DEEP_ARCHIVE: "DEEP_ARCHIVE",
  GLACIER: "GLACIER",
  GLACIER_IR: "GLACIER_IR",
  INTELLIGENT_TIERING: "INTELLIGENT_TIERING",
  ONEZONE_IA: "ONEZONE_IA",
  STANDARD_IA: "STANDARD_IA"
};
export var ExpirationStatus = {
  Disabled: "Disabled",
  Enabled: "Enabled"
};
export var TransitionDefaultMinimumObjectSize = {
  all_storage_classes_128K: "all_storage_classes_128K",
  varies_by_storage_class: "varies_by_storage_class"
};
export var BucketLogsPermission = {
  FULL_CONTROL: "FULL_CONTROL",
  READ: "READ",
  WRITE: "WRITE"
};
export var PartitionDateSource = {
  DeliveryTime: "DeliveryTime",
  EventTime: "EventTime"
};
export var MetricsFilter;
(function (MetricsFilter) {
  MetricsFilter.visit = function (value, visitor) {
    if (value.Prefix !== undefined) return visitor.Prefix(value.Prefix);
    if (value.Tag !== undefined) return visitor.Tag(value.Tag);
    if (value.AccessPointArn !== undefined) return visitor.AccessPointArn(value.AccessPointArn);
    if (value.And !== undefined) return visitor.And(value.And);
    return visitor._(value.$unknown[0], value.$unknown[1]);
  };
})(MetricsFilter || (MetricsFilter = {}));
export var Event = {
  s3_IntelligentTiering: "s3:IntelligentTiering",
  s3_LifecycleExpiration_: "s3:LifecycleExpiration:*",
  s3_LifecycleExpiration_Delete: "s3:LifecycleExpiration:Delete",
  s3_LifecycleExpiration_DeleteMarkerCreated: "s3:LifecycleExpiration:DeleteMarkerCreated",
  s3_LifecycleTransition: "s3:LifecycleTransition",
  s3_ObjectAcl_Put: "s3:ObjectAcl:Put",
  s3_ObjectCreated_: "s3:ObjectCreated:*",
  s3_ObjectCreated_CompleteMultipartUpload: "s3:ObjectCreated:CompleteMultipartUpload",
  s3_ObjectCreated_Copy: "s3:ObjectCreated:Copy",
  s3_ObjectCreated_Post: "s3:ObjectCreated:Post",
  s3_ObjectCreated_Put: "s3:ObjectCreated:Put",
  s3_ObjectRemoved_: "s3:ObjectRemoved:*",
  s3_ObjectRemoved_Delete: "s3:ObjectRemoved:Delete",
  s3_ObjectRemoved_DeleteMarkerCreated: "s3:ObjectRemoved:DeleteMarkerCreated",
  s3_ObjectRestore_: "s3:ObjectRestore:*",
  s3_ObjectRestore_Completed: "s3:ObjectRestore:Completed",
  s3_ObjectRestore_Delete: "s3:ObjectRestore:Delete",
  s3_ObjectRestore_Post: "s3:ObjectRestore:Post",
  s3_ObjectTagging_: "s3:ObjectTagging:*",
  s3_ObjectTagging_Delete: "s3:ObjectTagging:Delete",
  s3_ObjectTagging_Put: "s3:ObjectTagging:Put",
  s3_ReducedRedundancyLostObject: "s3:ReducedRedundancyLostObject",
  s3_Replication_: "s3:Replication:*",
  s3_Replication_OperationFailedReplication: "s3:Replication:OperationFailedReplication",
  s3_Replication_OperationMissedThreshold: "s3:Replication:OperationMissedThreshold",
  s3_Replication_OperationNotTracked: "s3:Replication:OperationNotTracked",
  s3_Replication_OperationReplicatedAfterThreshold: "s3:Replication:OperationReplicatedAfterThreshold"
};
export var FilterRuleName = {
  prefix: "prefix",
  suffix: "suffix"
};
export var DeleteMarkerReplicationStatus = {
  Disabled: "Disabled",
  Enabled: "Enabled"
};
export var MetricsStatus = {
  Disabled: "Disabled",
  Enabled: "Enabled"
};
export var ReplicationTimeStatus = {
  Disabled: "Disabled",
  Enabled: "Enabled"
};
export var ExistingObjectReplicationStatus = {
  Disabled: "Disabled",
  Enabled: "Enabled"
};
export var ReplicaModificationsStatus = {
  Disabled: "Disabled",
  Enabled: "Enabled"
};
export var SseKmsEncryptedObjectsStatus = {
  Disabled: "Disabled",
  Enabled: "Enabled"
};
export var ReplicationRuleStatus = {
  Disabled: "Disabled",
  Enabled: "Enabled"
};
export var Payer = {
  BucketOwner: "BucketOwner",
  Requester: "Requester"
};
export var MFADeleteStatus = {
  Disabled: "Disabled",
  Enabled: "Enabled"
};
export var BucketVersioningStatus = {
  Enabled: "Enabled",
  Suspended: "Suspended"
};
export var Protocol = {
  http: "http",
  https: "https"
};
export var ReplicationStatus = {
  COMPLETE: "COMPLETE",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  PENDING: "PENDING",
  REPLICA: "REPLICA"
};
export var ChecksumMode = {
  ENABLED: "ENABLED"
};
export var InvalidObjectState = /*#__PURE__*/function (_BaseException6) {
  _inherits(InvalidObjectState, _BaseException6);
  var _super6 = _createSuper(InvalidObjectState);
  function InvalidObjectState(opts) {
    var _this6;
    _classCallCheck(this, InvalidObjectState);
    _this6 = _super6.call(this, _objectSpread({
      name: "InvalidObjectState",
      $fault: "client"
    }, opts));
    _this6.name = "InvalidObjectState";
    _this6.$fault = "client";
    Object.setPrototypeOf(_assertThisInitialized(_this6), InvalidObjectState.prototype);
    _this6.StorageClass = opts.StorageClass;
    _this6.AccessTier = opts.AccessTier;
    return _this6;
  }
  return _createClass(InvalidObjectState);
}(__BaseException);
export var NoSuchKey = /*#__PURE__*/function (_BaseException7) {
  _inherits(NoSuchKey, _BaseException7);
  var _super7 = _createSuper(NoSuchKey);
  function NoSuchKey(opts) {
    var _this7;
    _classCallCheck(this, NoSuchKey);
    _this7 = _super7.call(this, _objectSpread({
      name: "NoSuchKey",
      $fault: "client"
    }, opts));
    _this7.name = "NoSuchKey";
    _this7.$fault = "client";
    Object.setPrototypeOf(_assertThisInitialized(_this7), NoSuchKey.prototype);
    return _this7;
  }
  return _createClass(NoSuchKey);
}(__BaseException);
export var ObjectAttributes = {
  CHECKSUM: "Checksum",
  ETAG: "ETag",
  OBJECT_PARTS: "ObjectParts",
  OBJECT_SIZE: "ObjectSize",
  STORAGE_CLASS: "StorageClass"
};
export var ObjectLockEnabled = {
  Enabled: "Enabled"
};
export var ObjectLockRetentionMode = {
  COMPLIANCE: "COMPLIANCE",
  GOVERNANCE: "GOVERNANCE"
};
export var NotFound = /*#__PURE__*/function (_BaseException8) {
  _inherits(NotFound, _BaseException8);
  var _super8 = _createSuper(NotFound);
  function NotFound(opts) {
    var _this8;
    _classCallCheck(this, NotFound);
    _this8 = _super8.call(this, _objectSpread({
      name: "NotFound",
      $fault: "client"
    }, opts));
    _this8.name = "NotFound";
    _this8.$fault = "client";
    Object.setPrototypeOf(_assertThisInitialized(_this8), NotFound.prototype);
    return _this8;
  }
  return _createClass(NotFound);
}(__BaseException);
export var ArchiveStatus = {
  ARCHIVE_ACCESS: "ARCHIVE_ACCESS",
  DEEP_ARCHIVE_ACCESS: "DEEP_ARCHIVE_ACCESS"
};
export var EncodingType = {
  url: "url"
};
export var ObjectStorageClass = {
  DEEP_ARCHIVE: "DEEP_ARCHIVE",
  EXPRESS_ONEZONE: "EXPRESS_ONEZONE",
  GLACIER: "GLACIER",
  GLACIER_IR: "GLACIER_IR",
  INTELLIGENT_TIERING: "INTELLIGENT_TIERING",
  ONEZONE_IA: "ONEZONE_IA",
  OUTPOSTS: "OUTPOSTS",
  REDUCED_REDUNDANCY: "REDUCED_REDUNDANCY",
  SNOW: "SNOW",
  STANDARD: "STANDARD",
  STANDARD_IA: "STANDARD_IA"
};
export var OptionalObjectAttributes = {
  RESTORE_STATUS: "RestoreStatus"
};
export var ObjectVersionStorageClass = {
  STANDARD: "STANDARD"
};
export var CompleteMultipartUploadOutputFilterSensitiveLog = function CompleteMultipartUploadOutputFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.SSEKMSKeyId && {
    SSEKMSKeyId: SENSITIVE_STRING
  });
};
export var CompleteMultipartUploadRequestFilterSensitiveLog = function CompleteMultipartUploadRequestFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.SSECustomerKey && {
    SSECustomerKey: SENSITIVE_STRING
  });
};
export var CopyObjectOutputFilterSensitiveLog = function CopyObjectOutputFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread(_objectSpread({}, obj), obj.SSEKMSKeyId && {
    SSEKMSKeyId: SENSITIVE_STRING
  }), obj.SSEKMSEncryptionContext && {
    SSEKMSEncryptionContext: SENSITIVE_STRING
  });
};
export var CopyObjectRequestFilterSensitiveLog = function CopyObjectRequestFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, obj), obj.SSECustomerKey && {
    SSECustomerKey: SENSITIVE_STRING
  }), obj.SSEKMSKeyId && {
    SSEKMSKeyId: SENSITIVE_STRING
  }), obj.SSEKMSEncryptionContext && {
    SSEKMSEncryptionContext: SENSITIVE_STRING
  }), obj.CopySourceSSECustomerKey && {
    CopySourceSSECustomerKey: SENSITIVE_STRING
  });
};
export var CreateMultipartUploadOutputFilterSensitiveLog = function CreateMultipartUploadOutputFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread(_objectSpread({}, obj), obj.SSEKMSKeyId && {
    SSEKMSKeyId: SENSITIVE_STRING
  }), obj.SSEKMSEncryptionContext && {
    SSEKMSEncryptionContext: SENSITIVE_STRING
  });
};
export var CreateMultipartUploadRequestFilterSensitiveLog = function CreateMultipartUploadRequestFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, obj), obj.SSECustomerKey && {
    SSECustomerKey: SENSITIVE_STRING
  }), obj.SSEKMSKeyId && {
    SSEKMSKeyId: SENSITIVE_STRING
  }), obj.SSEKMSEncryptionContext && {
    SSEKMSEncryptionContext: SENSITIVE_STRING
  });
};
export var SessionCredentialsFilterSensitiveLog = function SessionCredentialsFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread(_objectSpread({}, obj), obj.SecretAccessKey && {
    SecretAccessKey: SENSITIVE_STRING
  }), obj.SessionToken && {
    SessionToken: SENSITIVE_STRING
  });
};
export var CreateSessionOutputFilterSensitiveLog = function CreateSessionOutputFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, obj), obj.SSEKMSKeyId && {
    SSEKMSKeyId: SENSITIVE_STRING
  }), obj.SSEKMSEncryptionContext && {
    SSEKMSEncryptionContext: SENSITIVE_STRING
  }), obj.Credentials && {
    Credentials: SessionCredentialsFilterSensitiveLog(obj.Credentials)
  });
};
export var CreateSessionRequestFilterSensitiveLog = function CreateSessionRequestFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread(_objectSpread({}, obj), obj.SSEKMSKeyId && {
    SSEKMSKeyId: SENSITIVE_STRING
  }), obj.SSEKMSEncryptionContext && {
    SSEKMSEncryptionContext: SENSITIVE_STRING
  });
};
export var ServerSideEncryptionByDefaultFilterSensitiveLog = function ServerSideEncryptionByDefaultFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.KMSMasterKeyID && {
    KMSMasterKeyID: SENSITIVE_STRING
  });
};
export var ServerSideEncryptionRuleFilterSensitiveLog = function ServerSideEncryptionRuleFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.ApplyServerSideEncryptionByDefault && {
    ApplyServerSideEncryptionByDefault: ServerSideEncryptionByDefaultFilterSensitiveLog(obj.ApplyServerSideEncryptionByDefault)
  });
};
export var ServerSideEncryptionConfigurationFilterSensitiveLog = function ServerSideEncryptionConfigurationFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.Rules && {
    Rules: obj.Rules.map(function (item) {
      return ServerSideEncryptionRuleFilterSensitiveLog(item);
    })
  });
};
export var GetBucketEncryptionOutputFilterSensitiveLog = function GetBucketEncryptionOutputFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.ServerSideEncryptionConfiguration && {
    ServerSideEncryptionConfiguration: ServerSideEncryptionConfigurationFilterSensitiveLog(obj.ServerSideEncryptionConfiguration)
  });
};
export var SSEKMSFilterSensitiveLog = function SSEKMSFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.KeyId && {
    KeyId: SENSITIVE_STRING
  });
};
export var InventoryEncryptionFilterSensitiveLog = function InventoryEncryptionFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.SSEKMS && {
    SSEKMS: SSEKMSFilterSensitiveLog(obj.SSEKMS)
  });
};
export var InventoryS3BucketDestinationFilterSensitiveLog = function InventoryS3BucketDestinationFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.Encryption && {
    Encryption: InventoryEncryptionFilterSensitiveLog(obj.Encryption)
  });
};
export var InventoryDestinationFilterSensitiveLog = function InventoryDestinationFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.S3BucketDestination && {
    S3BucketDestination: InventoryS3BucketDestinationFilterSensitiveLog(obj.S3BucketDestination)
  });
};
export var InventoryConfigurationFilterSensitiveLog = function InventoryConfigurationFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.Destination && {
    Destination: InventoryDestinationFilterSensitiveLog(obj.Destination)
  });
};
export var GetBucketInventoryConfigurationOutputFilterSensitiveLog = function GetBucketInventoryConfigurationOutputFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.InventoryConfiguration && {
    InventoryConfiguration: InventoryConfigurationFilterSensitiveLog(obj.InventoryConfiguration)
  });
};
export var GetObjectOutputFilterSensitiveLog = function GetObjectOutputFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.SSEKMSKeyId && {
    SSEKMSKeyId: SENSITIVE_STRING
  });
};
export var GetObjectRequestFilterSensitiveLog = function GetObjectRequestFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.SSECustomerKey && {
    SSECustomerKey: SENSITIVE_STRING
  });
};
export var GetObjectAttributesRequestFilterSensitiveLog = function GetObjectAttributesRequestFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.SSECustomerKey && {
    SSECustomerKey: SENSITIVE_STRING
  });
};
export var GetObjectTorrentOutputFilterSensitiveLog = function GetObjectTorrentOutputFilterSensitiveLog(obj) {
  return _objectSpread({}, obj);
};
export var HeadObjectOutputFilterSensitiveLog = function HeadObjectOutputFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.SSEKMSKeyId && {
    SSEKMSKeyId: SENSITIVE_STRING
  });
};
export var HeadObjectRequestFilterSensitiveLog = function HeadObjectRequestFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.SSECustomerKey && {
    SSECustomerKey: SENSITIVE_STRING
  });
};
export var ListBucketInventoryConfigurationsOutputFilterSensitiveLog = function ListBucketInventoryConfigurationsOutputFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.InventoryConfigurationList && {
    InventoryConfigurationList: obj.InventoryConfigurationList.map(function (item) {
      return InventoryConfigurationFilterSensitiveLog(item);
    })
  });
};
export var ListPartsRequestFilterSensitiveLog = function ListPartsRequestFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.SSECustomerKey && {
    SSECustomerKey: SENSITIVE_STRING
  });
};